import keyBy from 'lodash.keyby';
import { useMemo } from 'react';
import { useFetchConversations } from '../../hooks/data-fetching/useFetchConversations';
import useHasPermission from '../../hooks/useHasPermission';
import { conversationIndicatorStatus } from '../../utils/texting';
import { useAppFlags } from '../../utils/featureFlags';

export function injectConversations(Component) {
  function HOC(props) {
    const prospectIds = useMemo(
      () => props.prospects.map((p) => p.id).flat(),
      [props.prospects],
    );

    const { leslie: leslieEnabled } = useAppFlags();
    const hasCommunicationCreatePermission = useHasPermission(
      'communication-create',
    );
    const showTextingColumn =
      props.selectedProperty.isTwoWayCommunicationActive &&
      hasCommunicationCreatePermission;

    const [conversations] = useFetchConversations(
      prospectIds,
      showTextingColumn,
    );

    const householdConversationsStatusDictionary = useMemo(() => {
      const conversationsDictionary = keyBy(
        conversations,
        (c) => c.recipient.prospectId,
      );

      return props.prospects.reduce((acc, prospect) => {
        const conversation = conversationsDictionary[prospect.id] ?? {};
        const status = conversationIndicatorStatus(conversation, leslieEnabled);
        const householdConversationsStatus = {
          NEEDS_HELP: status === 'NEEDS_HELP' ? 1 : 0,
          NEW: status === 'NEW' ? 1 : 0,
          UNRESOLVED: status === 'UNRESOLVED' ? 1 : 0,
          RESOLVED: status === 'RESOLVED' ? 1 : 0,
        };

        householdConversationsStatus.TOTAL =
          householdConversationsStatus.NEEDS_HELP +
          householdConversationsStatus.NEW +
          householdConversationsStatus.UNRESOLVED;

        acc[prospect.id] = householdConversationsStatus;

        return acc;
      }, {});
    }, [conversations, props.prospects, leslieEnabled]);

    return (
      <Component
        householdConversationsStatusDictionary={
          householdConversationsStatusDictionary
        }
        showTextingColumn={showTextingColumn}
        {...props}
      />
    );
  }

  return HOC;
}
